package org.burnoutcrew.reorderable

data class ItemPosition(val index: Int, val key: Any?)